import posthog from 'posthog-js'

const BASE_URL = process.env.BUN_PUBLIC_APP_BASE_URL ?? ''

export function posthogInit(key: string | undefined) {
  posthog.init(key ?? '', {
    // PostHog managed reverse proxy for the kanguroinsurance.com TLD (ad-blocker-resilient,
    // first-party ingestion). app.kanguroinsurance.com is the only deployed host for this app.
    // NOTE: j.kanguroinsurance.com must be provisioned as a PostHog managed proxy (+ DNS CNAME)
    // before this is merged; until then the old Vercel /pht proxy keeps running.
    api_host: BASE_URL ? 'https://j.kanguroinsurance.com' : 'https://us.i.posthog.com',
    ui_host: 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: false,
    capture_pageleave: false,
    capture_exceptions: true,
    opt_in_site_apps: false,
  })
}
